import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';
import qs from 'query-string';

import LoadingModal from '../../../components/atoms/LoadingModal/index';
import { ROUTE_CONSTANTS } from '../../../shared/constants/Route';
import VideoListScreen from '../../../components/molecules/VideoList';
import { ScreenTitle } from '../../../components/atoms';

const VideoScreen = ({
  userId,
  sessionToken,
  loading,
  videoTopics = [],
  history,
  enqueueSnackbar,
  getListOfVideoMainTopics = () => {
  },
  getListOfVideosInTopic = () => {
  },
}) => {
  let { query: { topic_id = '' } = {} } = qs.parseUrl(window.location.href);
  const [videoLists, updateVideoList] = useState([]);
  const [title, updateTitle] = useState('');

  const fetchVideoMainTopics = () => {
    const videosTopicRequestBody = {
      userId: userId,
      sessionToken: sessionToken,
    };
    getListOfVideoMainTopics(videosTopicRequestBody, (message, type) => {
      enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  };

  useEffect(() => {
    fetchVideoMainTopics();
  }, []);

  useEffect(() => {
    topic_id ? fetchVideoList() : updateTitle('');
  }, [topic_id]);

  const fetchVideoList = () => {
    const videoRequestBody = {
      userId,
      topicId: topic_id,
      sessionToken,
    };
    getListOfVideosInTopic(
      videoRequestBody,
      (videos) => {
        updateVideoList([...videos]);
      },
      (message, type) => {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
    );
  };
  return (
    <>
      <ScreenTitle
        title={
          topic_id
            ? title
              ? title
              : videoLists.length
                ? videoLists[0].topicName
                : ''
            : 'Videos'
        }
      />
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : topic_id ? (
        <VideoListScreen videoLists={videoLists}/>
      ) : (
        <div className='card-summary-container video_grids'>
          <div className='row'>
            {videoTopics.map((item) => {
              let { cateName, video_count, id } = item;
              return (
                <div
                  className='col6'
                  key={id}
                  item
                  onClick={() => {
                    updateTitle(cateName);
                    history.push(
                      `${ROUTE_CONSTANTS.VIDEOS}?topic_id=${item.id}`,
                    );
                  }}
                >
                  <div className='card-summary list_videos'>
                    <h6 style={{ fontWeight: 'bold' }}>{cateName}</h6>
                    <span>Contains {video_count} Video(s)</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default withSnackbar(VideoScreen);
